import styled, { createGlobalStyle } from 'styled-components'

import { MEDIA } from 'utils/constants'

const { MOBILE } = MEDIA

export const ProfileRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  padding-bottom: 16px;
  flex: 1;
  &:first-child {
    background-color: var(--the-white);
    top: 0;
  }
  &:not(:last-child) {
    border-bottom: 1px solid var(--silver);
  }
  @media screen and ${MOBILE} {
    flex-wrap: wrap;
    justify-content: center;
  }
`

export const ProfileCol = styled.div`
  text-align: left;
  flex: 1;
  display: inline-flex;
  ${props => props.maxWidth && `max-width: ${props.maxWidth};`}
  @media screen and ${MOBILE} {
    width: 100%;
        flex-direction: column-reverse;
  }
`

export const ProfileColContent = styled.div`
  text-align: left;
  flex: 1;
  display: inline-flex;
  ${props => props.maxWidth && `max-width: ${props.maxWidth};`}
  @media screen and ${MOBILE} {
    width: 100%;
  }
`

export const ProfileColDetail = styled.div`
  text-align: left;
  flex: 1;
  &:first-child {
    flex: 0 0 328px;
  }
  ${props => props.maxWidth && `max-width: ${props.maxWidth};`}
  @media screen and ${MOBILE} {
    width: 100%;
    max-width: unset;
    flex: 1 !important;
  }
`

export const ProfilePhoto = styled.div`
  width: 88px;
  height: 88px;
  border-radius: 50%;
  padding: 3px 2px 2px 3px;

  img{
    margin: 0px;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: contain;
  }

  &.noPhoto {
    background-color: var(--light-slate);
    padding: 0px;
    display: flex;
    align-items: center;
    justify-content: center;

    img{
      width: 88px;
      height: 88px;
      border-radius: 50%;
      object-fit: contain;
    }
  }
`

export const ProfileInfo = styled.div`
  padding-left: 18px;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  margin-right: 10px;

  h3 {
    font-size: 20px;
    font-family: var(--primary-font);
    color: var(--gray-2);
    margin-bottom: 12px;
  }

  h4 {
    display: inline-block;
    vertical-align: center;
    font-family: var(--primary-font);
    font-size: 16px;
    font-size: 16px;
    font-weight: 600;
    color: var(--gray-5);
    margin-bottom: 4px;
  }

  h5 {
    vertical-align: center;
    margin-bottom: 8px;
    font-family: var(--primary-font);
    font-size: 14px;
    font-weight: 400;
    color: var(--gray-5);
  }

`

export const HighlightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const ProfileCertifieds = styled.div`
  width: 100%;
  text-align: left;
  padding: 16px;
  background: var(--pet-anjo-lighter-blue);
  border-radius: 2.4rem;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;

  h4 {
    text-align: left;
    font-size: 14px;
    font-weight: 600;
    color: var(--gray-4);
    margin: 16px 0;
  }
  img {
    margin-left: 0px;
    margin-right: 8px;
    width: 40px;
    height: 40px;
    background-color: white;
    border-radius: 50%;
    padding: 8px;
  }

  label {
    vertical-align: super;
    line-height: 19px;
    font-family: var(--primary-font);
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0px;
  }

  p {
    min-height: 40px;
    text-align: left;
    font-family: var(--primary-font);
    font-weight: 400;
    font-size: 13px;
    letter-spacing: 0px;
    color: var(--gray-5);
    word-break: break-word;
  }

  button {
    font-family: var(--primary-font);
    font-weight: bold;
    font-size: 14px;
    right: 0px;
    bottom: 0px;
    background: var(--the-white);
    border: 0px;
    color: var(--schedule-blue);
    margin-left: 5px;

    &:hover {
      text-decoration: underline;
    }
  }
`

export const ProfileAbout = styled.div`
  width: 100%;
  text-align: left;
  padding: 16px;
  background: var(--pet-anjo-lighter-blue);
  border-radius: 2.4rem;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;

  h4 {
    font-size: 16px;
    font-family: var(--primary-font);
    font-weight: 600;
    letter-spacing: 0px;
    color: var(--gray-4);
    margin-bottom: 8px;
  }

  p {
    font-size: 13px;
    font-family: var(--primary-font);
    font-weight: 400;
    letter-spacing: 0px;
    color: var(--gray-5);
  }

  @media screen and ${MOBILE} {
    width: 100%;
    min-height: 245px;

    h4 {
      font-size: 14px;
    }

    p {
      font-size: 14px;
    }
  }
`

export const ProfilePets = styled.div`
  margin-top: 24px;
  border-bottom: 1px solid var(--silver);
  padding-bottom: 16px;

  h4 {
    text-align: center;
    font-size: 16px;
    font-family: var(--primary-font);
    font-weight: 600;
    letter-spacing: 0px;
    color: var(--gray-2);
    margin-bottom: 16px;
  }

  ul {
    list-style: none;
    display: flex;
    justify-content: center;
    align-items: start;
    gap: 24px;
    padding: 0 16px;

    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 4px;
      img {
        width: 32px;
        margin: 0px;
      }
      .notActive {
        opacity: .35;
      }
      span {
        font-family: var(--primary-font);
        font-size: 12px;
        font-weight: 400;
        line-height: normal;
        text-align: center;
      }
    }
  }

  p {
    padding-bottom: 24px;
    font-size: 13px;

    img {
      margin-left: 0px;
      margin-right: 9px;
      width: 6px;
    }

    label {
      font-family: var(--primary-font);
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 0px;
      color: var(--the-red);
    }
  }

  @media screen and ${MOBILE} {
    margin-top: 16px;
    margin-left: 0px;

    ul {
      justify-content: space-between;
      li {
        margin: 0px;
        img {
          margin-left: 0px;
        }
      }
    }

    p {
      padding-bottom: 16px;
    }
  }

`

export const ProfileServices = styled.div`
  margin-top: 16px;
  margin-left: 30px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--silver);
  h4 {
    text-align: center;
    margin-bottom: 16px;
    font-size: 16px;
    font-family: var(--primary-font);
    font-weight: 600;
    letter-spacing: 0px;
    color: var(--the-black);
  }

  ul {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    row-gap: 16px;

    li {
      width: 50%;
      display: flex;
      align-items: center;
      gap: 16px;

      label {
        line-height: 17.7px;
        font-size: 13px;
        font-weight: 600;
        font-family: var(--primary-font);
        color: var(--gray-5);
      }
    }
  }

  @media screen and ${MOBILE} {
    margin-top: 0px;
    margin-left: 0px;
    h4 {
      padding: 16px;
    }
  }
`

export const ServiceIcon = styled.div`
  height: 20px;
  width: 20px;
  img {
    height: 100%;
  }
`

export const ProfileStars = styled.div`
  padding-left: 30px;

  p {
    text-align: left;
    font-size: 14px;
    font-family: var(--primary-font);
    font-weight: 600;
    letter-spacing: 0px;
    color: var(--aqua-teal);

    svg {
      margin-left: 0px;
      margin-right: 7px;
    }

    label {
      vertical-align: text-bottom;
    }
  }

  @media screen and ${MOBILE} {
    margin-top: 0px;
    padding-left: 0px;
  }
`

export const ProfileRatings = styled.div`
  margin-left: 30px;
  margin-top: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--silver);
  @media screen and ${MOBILE} {
    margin-left: 0px;
  }
  h4 {
    font-size: 16px;
    font-family: var(--primary-font);
    font-weight: 600;
    letter-spacing: 0px;
    color: var(--gray-2);
    margin-bottom: 16px;
    line-height: 19.2px;
  }
`

export const ClientRatings = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  section {
    display: flex;
    gap: 8px;
    &:first-child {
      gap: 24px;
    }

    p {
      font-family: var(--primary-font);
      color: var(--gray-5);
      font-weight: 400;
      font-size: 14px;
      b {
        font-weight: 600;
      }
    }

  }
`

export const RatingContainer = styled.div`
  word-break: break-word;
`
export const IconWrapper = styled.div`
  padding: 4px;
`

export const ProfileRatingItem = styled.div`
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  line-height: 20.3px;
  font-weight: 400;
  font-family: var(--primary-font);
  color: var(--gray-5);
  margin-top: 2px;
  gap: 16px;
  p{
    margin-left: 3px;
  }

  &:not(:last-of-type) {
    margin-bottom: 16px;
  }

  .react-simple-star-rating span svg {
    margin: 0 3px;
  }

  .react-simple-star-rating span[title]{
    pointer-events: none;
    cursor: default;
  }
`
export const UsernameInfo = styled.p`
  font-weight: bold !important;
`

export const DateInfo = styled.p`
  font-size: 13px;
  color: var(--dim-gray);
  margin-bottom: 8px;
`

export const ProfileRatingReadMore = styled.button`
  font-family: var(--primary-font);
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.96px;
  color: var(--cobasi-blue-light-8);
  width: 100%;
  text-align: center;
  background: none;
  border: 0px;
  outline: 0px;
  margin-top: 16px;
  cursor: pointer;
  &:disabled {
    display: none;
  }
`

export const RatingsLoader = styled.div`
  text-align: center;

  img {
    width: 70px;
  }
`

export const GlobalStyle = createGlobalStyle`
  /* Works on Firefox */
  * {
    scrollbar-width: thin;
  }

  /* Works on Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  *::-webkit-scrollbar-thumb {
    border-radius: 2.4rem;
    border: 5px solid var(--pale-silver);
  }

  .react-simple-star-rating {
    z-index: -1;
  }
`

export const ModalClose = styled.div`
  display: flex;
  align-items: start;
  justify-content: flex-end;
  line-height: 24px;
  right: 32px;
  top: 24px;
  z-index: 999;
  margin-bottom: 16px;
  @media screen and ${MOBILE} {
    line-height: 24px;
    position: initial;
    display: block;
  }

  svg {
    filter: 'brightness(200%)';
  }
`

export const ModalCloseButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  color: var(--cobasi-blue-light-8);
  display: flex;
  align-items: center;
  font-family: var(--primary-font);
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  margin-right: 8px;

  svg {
    fill: var(--cobasi-blue-light-8);
  }
`
